import { monitoring } from '../appMonitoring'
import withMonitoringFactory from './withMonitoring.factory'

export const withMonitoring = withMonitoringFactory(monitoring)
